import { defaultFetch } from './baseApi';

type CoordinatorType = {
	isCoordinator: boolean;
	isProjectOwner: boolean;
	hasCoordinatorRole: boolean;
};
export const getCoordinatorByProjectId = async (projectId: string) => {
	const url = `/v0/projects/${projectId}/coordinator`;
	return defaultFetch<CoordinatorType>(url);
};
